module.exports = __webpack_public_path__ + "static/1invgde-6319f880052775902543bf126246f72c.gif";